import {NgModule} from '@angular/core';
import { MatLegacySliderModule } from '@angular/material/legacy-slider';
import { CommonModule } from '@angular/common';

import { AudioControlsComponent } from './components/audio-controls/audio-controls.component';
import {SharedModule} from '../shared/shared.module';

@NgModule({
  declarations: [
    AudioControlsComponent,
  ],
  entryComponents: [
    AudioControlsComponent,
  ],
  imports: [
    CommonModule,
    MatLegacySliderModule,
    SharedModule,
  ],
  exports: [
    AudioControlsComponent,
  ],
})
export class AudioModule {
}
